import { Empty, Table } from "antd";
import React, { useEffect, useState } from "react";
import style from "css/mypage.module.css";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { closeAlert, openAlert, openConfirm } from "redux/slices/alertSlice";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

function Pasttable(props) {
  console.log("props.datalist ", props.datalist)
  const { t } = useTranslation();
  let today = new Date();
  const payload = useSelector((state) => state.user);
  const duration = (start, end) => {
    let startTime = moment(start);
    let endTime = moment(end);
    let diff = {
      month: moment.duration(endTime.diff(startTime)).months(),
      day: moment.duration(endTime.diff(startTime)).days(),
      hour: moment.duration(endTime.diff(startTime)).hours(),
      minute: moment.duration(endTime.diff(startTime)).minutes(),
      second: moment.duration(endTime.diff(startTime)).seconds(),
    };

    if (diff.month < 1 && diff.day < 1 && diff.hour < 1 && diff.minute < 10) {
      if (diff.minute < 1) {
        return (
          <div className={style.list_start}>
            <div className={style.list_start_dot} />
            {t("MEETING.STATUS.ONGOING")}
          </div>
        );
      } else {
        return (
          <div className={style.list_start}>
            <div className={style.list_start_dot} />
            {t("MEETING.STATUS.MIN_BEFORE", { TIME: diff.minute })}
          </div>
        );
      }
    } else {
      return false;
    }
  };
  const checkstatus = (start, end) => {
    let startTime = moment(start);
    let endTime = moment(end);
    let diff = {
      month: moment.duration(endTime.diff(startTime)).months(),
      day: moment.duration(endTime.diff(startTime)).days(),
      hour: moment.duration(endTime.diff(startTime)).hours(),
      minute: moment.duration(endTime.diff(startTime)).minutes(),
      second: moment.duration(endTime.diff(startTime)).seconds(),
    };

    if (diff.month < 1 && diff.day < 1 && diff.hour < 1 && diff.minute < 30) {
      return false;
    } else {
      return true;
    }
  };

  function formatDateRange(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const startYear = start.getFullYear();
    const startMonth = String(start.getMonth() + 1).padStart(2, '0');
    const startDay = String(start.getDate()).padStart(2, '0');

    const endYear = end.getFullYear();
    const endMonth = String(end.getMonth() + 1).padStart(2, '0');
    const endDay = String(end.getDate()).padStart(2, '0');

    if (startYear === endYear && startMonth === endMonth && startDay === endDay) {
      return `${startYear}-${startMonth}-${startDay}`;
    } else {
      return `${startYear}-${startMonth}-${startDay} ~ ${endMonth}-${endDay}`;
    }
  }

  function getLocation(dept_nm, resource_nm) {
    const dept = dept_nm ? `${dept_nm} > ` : '';
    const resource = resource_nm;

    return `${dept}${resource}`
  }

  const columns = [
    {
      title: t("LIST.MEETING_DATE"),
      dataIndex: "DATE",
      key: "DATE",
      width: "15%",
      align: "center",
      render: (text, key) => (
        <div>
          {formatDateRange(key.START_DATE_LIST, key.END_DATE_LIST)}
        </div>
      ),
    },
    {
      title: t("LIST.MEETING_TIME"),
      dataIndex: "TIME",
      key: "TIME",
      width: "15%",
      align: "center",
      render: (text, key) => (
        <div className={style.list_time} style={{ display: 'flex', justifyContent: 'center' }}>
          <div className={style.list_txt}>
            {`${key.START_TIME_LIST} ~ ${key.END_TIME_LIST}`}
          </div>
        </div>
      ),
    },
    {
      title: props.scheduleType === 'M' ? t("LIST.MEETING_TITLE") : t("LIST.LOCATION_MEETING_NAME"),
      dataIndex: "TITLE",
      // width: "20%",
      align: "center",
      key: "TITLE",
      ellipsis: {
        showTitle: true,
      },
      render: (text, key) => <div>{key.RES_TYPE ? key.RESOURCE_TITLE : key.TITLE}</div>,
    },
    {
      title: props.scheduleType === 'M' ? t("LIST.MEETING_PLACE") : t("LIST.LOCATION"),
      dataIndex: "LOCATION",
      width: "25%",
      key: "LOCATION",
      align: "center",
      ellipsis: {
        showTitle: true,
      },
      render: (text, key) => {
        console.log("key ", key)
        return (
          <div>
            {key.RES_TYPE ? getLocation(key.LOCATION_DEPARTMENT_TITLE, key.LOCATION_TITLE) : key.ENDPOINT_LIST && key.ENDPOINT_LIST.map((endpoint) => endpoint.ENDPOINT_NM).join(", ")}
          </div>)
      },
    },
    {
      title: props.scheduleType ? t("LIST.MEETING_HOST") : '사용자',
      dataIndex: "HOST",
      width: "10%",
      key: "HOST",
      align: "center",
      render: (text, key) => <div>{key.RES_TYPE ? key.MEMBER_NM : key.HOST_NM}</div>,
    },
    {
      dataIndex: "OPTION",
      width: "10%",
      key: "OPTION",
      render: (text, key) => (
        <div>
          <div className={style.list_area} style={{ display: "flex", justifyContent: "center" }}>
            <div
              className={style.list_detail + " cursor"}
              onClick={() => {
                key.RES_TYPE ? props.openHotdeskPop(key) : props.openpop(true, key.SCHEDULE_ID)
              }}
            >
              <img
                className={style.list_OPTION_img}
                alt=""
                src={process.env.REACT_APP_CLIENT_URL + "img/mypage/search.png"}
              />
              {t("BTN.SHOW_DETAIL")}
            </div>
          </div>
        </div>
      ),
    },
  ];
  const [datalist, setdatalist] = useState([]);

  useEffect(() => {
    let mdatalist = [];
    for (let i = 0; i < props.datalist.length; i++) {
      for (let k = 0; k < props.datalist[i][1].length; k++) {
        if (props.scheduleType === 'M') {
          if (!props.datalist[i][1][k].hasOwnProperty("RES_TYPE")) {
            console.log("hot ", props.datalist[i][1][k])
            mdatalist.push(props.datalist[i][1][k]);
          }
        } else if (props.scheduleType === 'H') {
          if (props.datalist[i][1][k].hasOwnProperty("RES_TYPE")) {
            console.log("hot ", props.datalist[i][1][k])
            mdatalist.push(props.datalist[i][1][k]);
          }
        }
      }
    }
    setdatalist(mdatalist);
  }, [props.datalist, props.scheduleType]);

  return (
    <div>
      <Table
        columns={columns}
        dataSource={datalist}
        rowKey={"SCHEDULE_ID"}
        loading={props.loading}
        locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
      />
    </div>
  );
}

export default Pasttable;
